import React from 'react';
import ExternalSvg from 'components/ExternalSvg';

const ShakeShackIceCream = () => (
  <ExternalSvg customer="shakeshack" iconName="icecream" width="100%" height="90%" />
);

export default ShakeShackIceCream;
